module.exports = __webpack_public_path__ + "static/media/emergency maintenance notification.efc1147f.svg";